import { render, staticRenderFns } from "./leaveMsg.vue?vue&type=template&id=6fec1050&scoped=true&"
import script from "./leaveMsg.vue?vue&type=script&lang=js&"
export * from "./leaveMsg.vue?vue&type=script&lang=js&"
import style0 from "./leaveMsg.vue?vue&type=style&index=0&id=6fec1050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec1050",
  null
  
)

export default component.exports